import React, {useEffect, useState} from 'react';
import {ReactComponent as HandWaveIco} from "../../../../images/icons/hand-wave.svg";
import {useTranslation} from "react-i18next";
import {RootState} from "../../../../reducers";
import {getStoreConfig} from "../../../services/Store/reducer";
import {getSession} from "../../../services/Session/reducer";
import {connect, DispatchProp} from "react-redux";
import ResponsiveComponent from "../../../components/Common/ResponsiveComponent";
import {api} from "../../../services/Api/api";
import {addFlash} from "../../../services/Notifications/actions";
import handleException from "../../../services/Api/handleException";
import ChangeTableNumberModal from "../../../components/Modal/ChangeTableNumberModal";
import StoreUtils from "../../../services/Store/StoreUtils";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const CallWaiterStickyButton = ({session, config, dispatch}: Props) => {
    const {t} = useTranslation();
    const [bottomOffset, setBottomOffset] = useState(16);
    const [loading, setLoading] = useState(false);
    const [tableNumberModal, setTableNumberModal] = useState(false);
    const tableNumber = session.table_number;
    const preventRender = session.order_type !== "DINE_IN" || !config?.table.call_waiter || StoreUtils.isOrderingReadonly(config) || !StoreUtils.isQrcodeContext(session);

    useEffect(() => {
        if (preventRender) return;

        const stickyCartBtnContainer = document.querySelector(".fixed-bottom, .btn-cart-container");

        if (!stickyCartBtnContainer) {
            setBottomOffset(16);
            return;
        }

        const observer = new ResizeObserver(() => {
            requestAnimationFrame(() => {
                const rect = stickyCartBtnContainer.getBoundingClientRect();
                const newOffset = rect.height + 16;
                setBottomOffset(prev => (prev !== newOffset ? newOffset : prev));
            });
        });

        observer.observe(stickyCartBtnContainer);

        return () => observer.disconnect();
    }, [preventRender]);

    if (preventRender) return <></>;

    const handleClick = async () => {
        setLoading(true);

        if (tableNumber === undefined) {
            setTableNumberModal(true)
            setLoading(false);
            return;
        }

        try {
            await api.callWaiter(tableNumber);
            dispatch(addFlash('success', t("alert.success.call_waiter")));
        } catch (err) {
            const errors = handleException(err);
            dispatch(addFlash('error', errors));
        }
        setLoading(false);
    }

    return (
        <ResponsiveComponent
            small={
                <>
                    <ChangeTableNumberModal tableName={tableNumber} show={tableNumberModal}
                                            onSave={() => setTableNumberModal(false)}
                                            onHide={() => setTableNumberModal(false)}/>
                    <div className="fixed-bottom call-waiter-sticky-button-wrapper" style={{bottom: bottomOffset}}>
                        <button className={`btn btn-default btn-spinner ${loading ? "loading" : ""}`}
                                onClick={handleClick}>
                            <HandWaveIco className="me-2"/>
                            {t("modules.menu.action.call_waiter.title")}
                            <span className="left spinner-border spinner-border-sm me-2"/>
                        </button>
                    </div>
                </>
            }
            large={<></>}
            breakpoint={768}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    session: getSession(state.session),
});

const connector = connect(mapStateToProps);
export default connector(CallWaiterStickyButton);